import { zodResolver } from '@hookform/resolvers/zod';
import { TextField } from '@mui/material';
import { useForm } from 'react-hook-form';

import { DialogType } from '../../../@types';
import { QUERY_KEYS } from '../../../constants';
import API_ROUTES from '../../../constants/apiRoutes';
import useMutateData from '../../../hooks/useMutateData';
import { createSuperAdminAccountSchema, CreateSuperAdminAccountFormData } from '../../../schema';
import FormModalLayout from '../../layouts/FormModalLayout';
import PasswordFields from '../../molecules/PasswordFields';

export const DEFAULT_SUPER_ADMIN_ACCOUNT_DATA: CreateSuperAdminAccountFormData = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  confirmPassword: '',
};

const CreateSuperAdminAccountForm = ({ closeModal }: DialogType) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<CreateSuperAdminAccountFormData>({
    defaultValues: DEFAULT_SUPER_ADMIN_ACCOUNT_DATA,
    resolver: zodResolver(createSuperAdminAccountSchema),
  });
  const { createData, isLoading } = useMutateData(
    API_ROUTES.SUPER_ADMIN_ACCOUNTS,
    [QUERY_KEYS.superAdminAccounts],
    'crm'
  );

  const handleClose = () => {
    closeModal?.();
    reset(DEFAULT_SUPER_ADMIN_ACCOUNT_DATA);
  };

  const onSubmit = ({ confirmPassword: _confirmPassword, ...payload }: CreateSuperAdminAccountFormData) => {
    createData(payload, handleClose, 'Super admin account created successfully.');
  };

  return (
    <FormModalLayout
      label='Create super admin'
      actionButtonLabel='Create account'
      onSave={handleSubmit(onSubmit)}
      onClose={handleClose}
      disableSubmit={isLoading}
    >
      <TextField
        label='First Name'
        {...register('firstName')}
        error={!!errors.firstName}
        helperText={errors.firstName?.message}
        required
        fullWidth
      />
      <TextField
        label='Last Name'
        {...register('lastName')}
        error={!!errors.lastName}
        helperText={errors.lastName?.message}
        required
        fullWidth
      />
      <TextField
        label='Email'
        type='email'
        {...register('email')}
        error={!!errors.email}
        helperText={errors.email?.message}
        required
        fullWidth
      />
      <PasswordFields resetPassword={false} errors={errors} register={register} />
    </FormModalLayout>
  );
};

export default CreateSuperAdminAccountForm;
